import React from 'react'
import ReactDOM from 'react-dom/client'
import './app/scss/index.scss'
import App from './app/App'
import { createBrowserRouter } from 'react-router-dom'
import { RouterProvider } from 'react-router'
import { Main } from './pages/Main/Main'
import RedirectToAppWithRef from './pages/Redirect/RedirectToAppWithRef'

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                element: <Main />,
            },
            {
                path: '/open',
                element: <RedirectToAppWithRef />,
            },
        ],
    },
])

const root = ReactDOM.createRoot(
    document.getElementById('root')
)
root.render(<RouterProvider router={router} />)
